import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: "/scheme",
    name: "scheme",
    component: resolve => require(['../views/scheme.vue'], resolve)
  },
  {
    path: "/scheme_article",
    name: "scheme_article",
    component: resolve => require(['../views/scheme_article.vue'], resolve)
  },
  {
    path: "/product",
    name: "product",
    component: resolve => require(['../views/product.vue'], resolve)
  },
  {
    path: "/productInfo",
    name: "productInfo",
    component: resolve => require(['../views/productInfo.vue'], resolve)
  },
  {
    path: "/productTwo",
    name: "productTwo",
    component: resolve => require(['../views/productTwo.vue'], resolve)
  },
  {
    path: "/case",
    name: "case",
    component: resolve => require(['../views/case.vue'], resolve)
  },
  {
    path: "/caseInfo",
    name: "caseInfo",
    component: resolve => require(['../views/caseInfo.vue'], resolve)
  },
  {
    path: "/habits",
    name: "habits",
    component: resolve => require(['../views/habits.vue'], resolve)
  },
  {
    path: "/habitsInfo",
    name: "habitsInfo",
    component: resolve => require(['../views/habitsInfo.vue'], resolve)
  },
  {
    path: "/developer",
    name: "developer",
    component: (resolve) => require(["../views/developer.vue"], resolve),
  },
  {
    path: "/developerinfo",
    name: "developerinfo",
    component: (resolve) => require(["../views/developerinfo.vue"], resolve),
  },
  {
    path: "/document",
    name: "document",
    component: (resolve) => require(["../views/document.vue"], resolve),
  },
  {
    path: "/about",
    name: "about",
    component: resolve => require(['../views/about.vue'], resolve)
  },
  {
    path: "/login",
    name: "login",
    component: resolve => require(['../views/login.vue'], resolve)
  },
  {
    path: "/habitSearch",
    name: "habitSearch",
    component: resolve => require(['../views/habitSearch.vue'], resolve)
  },
  {
    path: "/caseInfoTwo",
    name: "caseInfoTwo",
    component: resolve => require(['../views/caseInfoTwo.vue'], resolve)
  },
  {
    path: "/schemeInfoTwo",
    name: "schemeInfoTwo",
    component: resolve => require(['../views/schemeInfoTwo.vue'], resolve)
  },
  {
    path: "/productInfoTwo",
    name: "productInfoTwo",
    component: resolve => require(['../views/productInfoTwo.vue'], resolve)
  },
  {
    path: "/productTwoShow",
    name: "productTwoShow",
    component: resolve => require(['../views/productTwoShow.vue'], resolve)
  },
  {
    path: "/industry",
    name: "industry",
    component: resolve => require(['../views/industry.vue'], resolve)
  },
  {
    path: "/phoneIndex",
    name: "phoneIndex",
    component: resolve => require(['../views/phoneIndex.vue'], resolve)
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  next();
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router

// {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
